import React from 'react';
import ReactDOM from 'react-dom';
import ReactDataGrid from 'react-data-grid';
import DateTime from 'react-datetime';

class DateEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: props.value,
    };

    this.handleDate = this.handleDate.bind(this);
  }

  getValue() {
    return { date: this.state.date };
  }

  getInputNode() {
    return ReactDOM.findDOMNode(this).getElementsByTagName('input')[0];
  }

  handleDate = (date) => {
    this.setState({ date: date.unix() }, () => this.props.onCommit());
  }

  render() {
    return (
      <DateTime
        name='date'
        timeFormat={false}
        onChange={this.handleDate}
        dateFormat='DD/MM/YYYY'
        value={this.state.date != null ? this.state.date * 1000 : null}
      />
    );
  }
}

export default DateEditor;


// WEBPACK FOOTER //
// ./src/Components/DataGrid/DateEditor.js